import { PaymentMethods } from '../../../models/payment-methods'
import { Roles } from '../../../models/roles'

export const StatisticFilters = {
  SALESPERSON_ID: {
    value: 'SALESPERSON_ID',
    name: 'statistics.filter.salesPerson',
    role: Roles.RESURS_ADMIN,
  },
  CHANNEL_TYPE: {
    value: 'CHANNEL_TYPE',
    dataset: 'channels.keys',
    name: 'statistics.filter.channel',
    role: Roles.RESURS_ADMIN,
  },
  CUSTOMER_TYPE: {
    value: 'CUSTOMER_TYPE',
    values: ['NATURAL', 'LEGAL'],
    name: 'statistics.filter.customerType',
    role: Roles.RESURS_ADMIN,
  },
  GENDER: {
    value: 'GENDER',
    dataset: 'gender.keys',
    name: 'statistics.filter.gender',
    role: Roles.RESURS_ADMIN,
  },
  NEW_CUSTOMER: {
    value: 'NEW_CUSTOMER',
    values: [true, false],
    name: 'statistics.filter.newCustomer',
    role: Roles.RESURS_ADMIN,
  },
  ACCOUNT_SYSTEM_STORE_ID: {
    value: 'ACCOUNT_SYSTEM_STORE_ID',
    name: 'statistics.filter.storeId',
    role: Roles.RESURS_ADMIN,
  },
  SIGNED_OR_IDENTIFIED: {
    value: 'SIGNED_OR_IDENTIFIED',
    values: [true, false],
    name: 'statistics.filter.signedOrIdentified',
    role: Roles.RESURS_ADMIN,
  },
  SIGNED: {
    value: 'SIGNED',
    values: [true, false],
    name: 'statistics.filter.signed',
    role: Roles.RESURS_ADMIN,
  },
  IDENTIFIED: {
    value: 'IDENTIFIED',
    values: [true, false],
    name: 'statistics.filter.identified',
    role: Roles.RESURS_ADMIN,
  },
  WAS_ESIGN_AVAILABLE: {
    value: 'WAS_ESIGN_AVAILABLE',
    values: [true, false],
    name: 'statistics.filter.eSignAvailable',
    role: Roles.RESURS_ADMIN,
  },
  SIGNING_TYPE: {
    value: 'SIGNING_TYPE',
    values: ['ELECTRONIC', 'PHYSICAL', 'NOT_APPLICABLE'],
    name: 'statistics.filter.signingType',
    role: Roles.RESURS_ADMIN,
  },
  PAYMENT_METHOD_NAME: {
    value: 'PAYMENT_METHOD_NAME',
    dataset: 'paymentmethods.keys',
    name: 'statistics.filter.paymentMethodName',
  },
  PAYMENT_METHOD_TYPE: {
    value: 'PAYMENT_METHOD_TYPE',
    values: Object.keys(PaymentMethods),
    name: 'statistics.filter.paymentMethodType',
    role: Roles.RESURS_ADMIN,
  },
  APPLICATION_TYPE: {
    value: 'APPLICATION_TYPE',
    values: ['NEW_ACCOUNT', 'LIMIT_INCREASE'],
    valueTranslations: {
      NEW_ACCOUNT: 'statistics.filter.NEW_ACCOUNT',
      LIMIT_INCREASE: 'statistics.filter.LIMIT_INCREASE',
    },
    name: 'statistics.filter.applicationType',
  },
  FIRST_PURCHASE_FOR_ACCOUNT: {
    value: 'FIRST_PURCHASE_FOR_ACCOUNT',
    values: [true, false],
    name: 'statistics.filter.firstPurchase',
    role: Roles.RESURS_ADMIN,
  },
}
